import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      id: 1,
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="24" cy="24" r="20" />
          <path d="M24 14v10l6 6" strokeLinecap="round" />
        </svg>
      ),
      title: 'Swipe Right',
      description: 'Swipe right to like someone. If they swipe right on you too, it\'s a match! Start chatting and get to know each other.'
    },
    {
      id: 2,
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 24c0-6.627 5.373-12 12-12s12 5.373 12 12" strokeLinecap="round" />
          <path d="M24 36v-8" strokeLinecap="round" />
          <circle cx="24" cy="24" r="4" />
          <path d="M8 24H4M44 24h-4M24 4v4M24 40v4" strokeLinecap="round" />
        </svg>
      ),
      title: 'Location Based',
      description: 'Find people near you. Adjust your distance settings to discover matches in your area or anywhere in the world.'
    },
    {
      id: 3,
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M24 44s-16-10-16-24c0-8.837 7.163-16 16-16s16 7.163 16 16c0 14-16 24-16 24z" />
          <circle cx="24" cy="20" r="6" />
        </svg>
      ),
      title: 'Smart Matching',
      description: 'Our smart algorithm learns your preferences and shows you people you\'re most likely to match with.'
    },
    {
      id: 4,
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4" strokeLinecap="round" />
          <path d="M24 4v20l14 7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      title: 'Video Chat',
      description: 'Get to know your matches face-to-face with video chat. Move from messaging to video calls seamlessly.'
    },
    {
      id: 5,
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 12h36M6 24h36M6 36h36" strokeLinecap="round" />
        </svg>
      ),
      title: 'Advanced Filters',
      description: 'Filter by age, distance, interests, and more. Find exactly who you\'re looking for with advanced preferences.'
    },
    {
      id: 6,
      icon: (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M24 4l5.196 10.528L40 16.583l-8 7.794 1.888 11.012L24 30.528l-9.888 4.861L16 24.377l-8-7.794 10.804-2.055L24 4z" />
        </svg>
      ),
      title: 'Super Likes',
      description: 'Stand out from the crowd with Super Likes. Let someone know you\'re really interested before they swipe.'
    }
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <div className="features-header">
          <h2 className="features-title">How It Works</h2>
          <p className="features-subtitle">
            Discover how millions of people are making meaningful connections every day
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div 
              key={feature.id} 
              className="feature-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
